import { Theme } from '@mui/material';

import { MaterialStyleMap } from '../../types';

export default (theme: Theme): MaterialStyleMap => ({
  MuiFormLabel: {
    styleOverrides: {
      root: {
        fontWeight: 'bold',
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        backgroundColor: theme.palette.grey.xxLight,
        borderRadius: '5px',
      },
    },
  },
  MuiPickersOutlinedInput: {
    styleOverrides: {
      root: {
        backgroundColor: theme.palette.grey.xxLight,
        borderRadius: '5px',
      },
    },
  },
});
